import * as React from "react";
import PropTypes from "prop-types";
import HLAppBar from "./HLAppBar";
import HLAppSideBar from "./HLAppSideBar";
import HLAppSideBarAndContent from "./HLAppSideBarAndContent";
import HLAppContent from "./HLAppContent";
import HLFooter from "../Other/HLFooter";
import * as Theme from "../../../app/Theme";
import * as GBConst from "../../GB/GBConst";

class HLMain extends React.Component {
    //==================================================================================================================
    //
    //                                             Props and State
    //
    //==================================================================================================================

    static propTypes = {
        apiTasks: PropTypes.array.isRequired,

        appState: PropTypes.any.isRequired,
        onStateChange: PropTypes.func.isRequired,

        onDrawerChange: PropTypes.func.isRequired,
        onSideBarArrowClick: PropTypes.func.isRequired,
        heartBeat: PropTypes.number.isRequired,
        onPackTableChange: PropTypes.func.isRequired,
        onPageChange: PropTypes.func.isRequired,
        onProjectionAdd: PropTypes.func.isRequired,

        onCountryChange: PropTypes.func,
        onFirstYearPopChange: PropTypes.func,
        onHIV_PrevChange: PropTypes.func,
        onIncludeIntervAreaChange: PropTypes.func,
        onIntervAreaScaleUpChange: PropTypes.func,
        onMalariaEndemicChange: PropTypes.func,
        onMortProfileChange: PropTypes.func,
        onRankedIntervMstIDArrayChange: PropTypes.func,
        onRecalcChange: PropTypes.func,
        onRegionChange: PropTypes.func,
        onResultWkbkFileURLChange: PropTypes.func,
        onShowAboutDialogChange: PropTypes.func,
        onShowChildrenIntervChange: PropTypes.func,
        onShowMaternalIntervChange: PropTypes.func,
        onStuntingIndChange: PropTypes.func,
        onWastingIndChange: PropTypes.func,
    };

    static defaultProps = {
        apiTasks: [],

        appState: null,
        onStateChange: () => {},

        onDrawerChange: () => {},
        onSideBarArrowClick: () => console.log("onSideBarArrowClick"),
        heartBeat: -1,
        onPackTableChange: () => {},
        onPageChange: () => {},
        onProjectionAdd: () => {},

        onCountryChange: () => console.log("onCountryChange"),
        onFirstYearPopChange: () => console.log("onFirstYearPopChange"),
        onHIV_PrevChange: () => console.log("onHIV_PrevChange"),
        onIncludeIntervAreaChange: () => console.log("onIncludeIntervAreaChange"),
        onIntervAreaScaleUpChange: () => console.log("onIntervAreaScaleUpChange"),
        onMalariaEndemicChange: () => console.log("onMalariaEndemicChange"),
        onMortProfileChange: () => console.log("onMortProfileChange"),
        onRankedIntervMstIDArrayChange: () => console.log("onRankedIntervMstIDArrayChange"),
        onRecalcChange: () => console.log("onRecalcChange"),
        onRegionChange: () => console.log("onRegionChange"),
        onResultWkbkFileURLChange: () => console.log("onResultWkbkFileURLChange"),
        onShowAboutDialogChange: () => console.log("onShowAboutDialogChange"),
        onShowChildrenIntervChange: () => console.log("onShowChildrenIntervChange"),
        onShowMaternalIntervChange: () => console.log("onShowMaternalIntervChange"),
        onStuntingIndChange: () => console.log("onStuntingIndChange"),
        onWastingIndChange: () => console.log("onWastingIndChange"),
    };

    myRef = React.createRef();

    componentDidMount() {
        if (this.myRef.current) {
            this.myRef.current.scrollIntoView({ block: "start", behavior: "smooth" });
        }
    }

    //==================================================================================================================
    //
    //                                                Render
    //
    //==================================================================================================================

    render() {
        const props = this.props;
        const onCountryChange = props.onCountryChange;
        const onFirstYearPopChange = props.onFirstYearPopChange;
        const onRecalcChange = props.onRecalcChange;

        /* state */

        const appState = this.props.appState;
        const screenSize = appState.screenSize;
        const sideBarOpen = appState.sideBarOpen;
        const showAboutDialog = appState.showAboutDialogBool;

        let appSideBarArrowBtnWidth = 0; // no longer showing arrow 40;
        let appSideBarWidthClosed = appSideBarArrowBtnWidth;
        let appSideBarWidthOpen = 280 + 40; // no longer showing arrow appSideBarArrowBtnWidth;

        let appSideBarWidth = 0;

        if (sideBarOpen) {
            appSideBarWidth = appSideBarWidthOpen;
        } else {
            appSideBarWidth = appSideBarWidthClosed;
        }

        const layout = {
            appBar: {
                height: 100,
            },

            appSideBar: {
                width: appSideBarWidth,
            },

            appBarTitleStyle: {
                cursor: "pointer",
                fontSize: "35px",
                ...Theme.appTitleFontStyle,
                marginLeft: 15, // makes put space between the word from the logo and the app title
                //marginTop  : 13, // makes the rest of the app title line up with the logo...not the best solution
                whiteSpace: "nowrap",
                width: 1100,
            },
        };

        const appBar = (
            <HLAppBar
                onDrawerChange={this.props.onDrawerChange}
                pageID={this.props.appState.pageID}
                onPageChange={this.props.onPageChange}
                screenSize={screenSize}
                onSideBarArrowClick={this.props.onSideBarArrowClick}
                showAboutDialog={showAboutDialog}
                onShowAboutDialogChange={this.props.onShowAboutDialogChange}
                titleStyle={layout.appBarTitleStyle}
            />
        );

        let appSideBar = null;

        if (this.props.appState.sideBarOpen) {
            appSideBar = (
                <HLAppSideBar
                    appState={this.props.appState}
                    pageID={this.props.appState.pageID}
                    onPageChange={this.props.onPageChange}
                    sideBarOpen={this.props.appState.sideBarOpen}
                    onSideBarArrowClick={this.props.onSideBarArrowClick}
                    sideBarWidthClosed={appSideBarArrowBtnWidth}
                    sideBarWidthOpen={appSideBarWidthOpen}
                    showAboutDialog={showAboutDialog}
                    onShowAboutDialogChange={this.props.onShowAboutDialogChange}
                />
            );
        }

        const appContent = (
            <HLAppContent
                appState={this.props.appState}
                onStateChange={this.props.onStateChange}
                onDrawerChange={this.props.onDrawerChange}
                appBarHeight={layout.appBar.height}
                left={layout.appSideBar.width}
                onPageChange={this.props.onPageChange}
                onSideBarArrowClick={this.props.onSideBarArrowClick}
                onCountryChange={onCountryChange}
                onFirstYearPopChange={onFirstYearPopChange}
                onHIV_PrevChange={this.props.onHIV_PrevChange}
                onIncludeIntervAreaChange={this.props.onIncludeIntervAreaChange}
                onIntervAreaScaleUpChange={this.props.onIntervAreaScaleUpChange}
                onMalariaEndemicChange={this.props.onMalariaEndemicChange}
                onMortProfileChange={this.props.onMortProfileChange}
                onRankedIntervMstIDArrayChange={this.props.onRankedIntervMstIDArrayChange}
                onRecalcChange={onRecalcChange}
                onRegionChange={this.props.onRegionChange}
                onResultWkbkFileURLChange={this.props.onResultWkbkFileURLChange}
                onShowChildrenIntervChange={this.props.onShowChildrenIntervChange}
                onShowMaternalIntervChange={this.props.onShowMaternalIntervChange}
                onStuntingIndChange={this.props.onStuntingIndChange}
                onWastingIndChange={this.props.onWastingIndChange}
            />
        );

        let footer = null;

        if (screenSize !== GBConst.smScreen) {
            footer = <HLFooter />;
        }

        const styles = {
            main: {
                overflowY: "auto",
                transition: "margin-left 450ms cubic-bezier(0.23, 1, 0.32, 1)",
                height: "calc(100% - 0px)",
            },
            appSideAndContent: {
                position: "absolute",
            },
        };

        return (
            <div className="Main" ref={this.myRef} style={styles.main}>
                {appBar}

                <HLAppSideBarAndContent
                    appBarHeight={layout.appBar.height}
                    top={layout.appBar.height}
                    style={styles.appSideAndContent}
                >
                    {appSideBar}
                    {appContent}
                </HLAppSideBarAndContent>

                {footer}
            </div>
        );
    }
}

export default HLMain;
